import React from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { CloseXIcon } from 'icons';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useAppSelector } from 'store';

import { useSendLead } from 'modules/course-detail';

interface IProps {
  onClose: () => void;
  open: boolean;
  setSuccessVisible: (open: boolean) => void;
  courseId?: number;
}

const LeadModal: React.FC<IProps> = ({ onClose, open, setSuccessVisible, courseId }) => {
  const t = useTranslations();
  const { mutate, isLoading: isSendLoading } = useSendLead();
  const [form] = Form.useForm();
  const user = useAppSelector(state => state.user);

  const onAfterSuccess = () => {
    setSuccessVisible(true);
    onClose();
    setTimeout(() => {
      setSuccessVisible(false);
    }, 2000);
  };

  const onFinish = (values: { phone: string; name: string }) => {
    const sanitizedPhone = values.phone.replace(/\s|-/g, '');
    const isPhoneValid = sanitizedPhone?.length === 13;

    if (!isPhoneValid) {
      form.setFields([
        {
          name: 'phone',
          errors: [t('Togri_telefon_raqam_kiriting')]
        }
      ]);
      return;
    }

    mutate(
      { name: values?.name, phone: sanitizedPhone, teacher_course_id: courseId },
      {
        onSuccess: onAfterSuccess
      }
    );
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onCancel={onClose}
      width="400px"
      closeIcon={
        <div className="flex items-center justify-center rounded-full bg-gray-800 p-1 text-white">
          <CloseXIcon size="12" />
        </div>
      }
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      afterOpenChange={() => form.resetFields()}
      title={<span className="text-lg">{t('ArizaQoldirish')}</span>}
    >
      <Form
        initialValues={{
          user_name: user?.name || user?.last_name ? `${user?.name ?? ''} ${user?.last_name ?? ''}`.trim() : undefined,
          phone: user?.phone || '+998'
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: ''
            }
          ]}
        >
          <Input
            className="!rounded-xl !bg-gray-100 hover:!border-green-500 focus:!border-green-500"
            placeholder={t('auth.first_name_placeholder')}
          />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true
            }
          ]}
        >
          <PatternFormat
            format="+### ## ### ## ##"
            allowEmptyFormatting={true}
            mask=" "
            type="tel"
            placeholder={t('auth.phone_placeholder')}
            className={` !h-11 !rounded-xl !border !p-3 hover:!border-green-500 ${
              form.getFieldError('phone')?.length ? '!border-red-500' : '!border-transparent'
            } w-full !bg-gray-100 hover:!outline-green-500 focus:!outline-green-500`}
          />
        </Form.Item>
        <p className="mb-3 text-gray-800">
          {t('malumotlaringizni_mutaxassislarimizga_yuboriladi_va_ular_siz_bilan_boglanishadi')}
        </p>

        <Button
          loading={isSendLoading}
          htmlType="submit"
          className="!mt-3 !w-full !rounded-lg !border-none !bg-green-500 !px-7 !py-5 !text-white hover:!border-none"
        >
          {t('Yuborish')}
        </Button>
      </Form>
    </Modal>
  );
};

export default LeadModal;
